import { useEffect, useState } from "react";

/**
 * "You're offline · showing what was saved at 14:05".
 *
 * Shown above a screen whose data came from the device. Says how old it is,
 * because a readiness figure from last week read as today's would mislead.
 */
export function OfflineNote({ since }: { since: number | null }) {
  const [online, setOnline] = useState(() =>
    typeof navigator === "undefined" ? true : navigator.onLine,
  );
  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);

  if (since === null) return null;
  const when = new Date(since);
  const today = new Date().toDateString() === when.toDateString();
  const label = today
    ? when.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })
    : when.toLocaleDateString("en-GB", { day: "numeric", month: "short" });

  return (
    <p
      role="status"
      className="m-0 border-b border-border bg-surface px-5 py-2 text-center text-[12px] text-text-muted"
    >
      {online ? "Couldn't reach PrepAI" : "You're offline"} · showing what was saved{" "}
      {today ? "at" : "on"} {label}. Downloaded subjects still work.
    </p>
  );
}
